{
    "locale": "en-US",
    "translations": {
        "account-type": "Account Type",
        "account-type-help": "Choose whether you want to create an account for a customer or for demo purposes.",
        "action": "Action",
        "add-attribute": "Add Attribute",
        "add-owner": "Add Owner",
        "add-role": "Add Role",
        "add-token-mapper": "Add Token Mapper",
        "add-url": "Add URL",
        "add-user": "Add User",
        "all-clients": "All SICK ID Clients",
        "all-requirements-met": "All requirements are met.",
        "application": "Application",
        "application-name": "SICK ID Self-Service Portal",
        "associated-clients": "Associated Clients",
        "attribute-key": "Attribute Key",
        "attribute-value": "Attribute Value",
        "attributes": "Attributes",
        "audience": "Audience",
        "audience-mapper-description": "Map a specific client or custom audience into the user's token. Applications should verify that the token they receive has been issued for the correct audience. Ususally, this can be a specific client ID. Some applications may require a custom audience.",
        "available-permissions": "Available Permissions:",
        "cancel": "Cancel",
        "cancel-editing": "Cancel Editing",
        "changes-saved": "Your changes have been saved.",
        "choose-admin-role": "Choose Role",
        "claim-name": "Claim Name",
        "client": "Client",
        "client-admin": "Client Admin",
        "client-admin-description": "Change all possible configurations of the client.",
        "client-admin-role-warning": "This role is only used to define the client administrators in the old service portal. For the new serviceportal, the permissions are managed in the permissions tab.",
        "client-admins": "Client Admins",
        "client-audience": "Client Audience",
        "client-auth-credentials": "Credentials",
        "client-deactivation-hint": "This client is deactivated. If you no longer need this client, please delete it. If you still need this client, reactivate it and make sure to regularly login to the client.",
        "client-description-help": "Document the purpose of this client and its corresponding application for other client managers.",
        "client-id": "Client ID",
        "client-id-help": "A technical ID to configure the authentication flow in your OIDC/OAuth library. We recommend to use a human readable name, e.g. asset-hub.",
        "client-inactive-warning": "The client has not been used for a long time. Delete the client if it is no longer needed.",
        "client-name": "Client Name",
        "client-name-help": "Human readable name of the client. This name might be displayed to a user, e.g. if they want to see their current login sessions.",
        "client-permissions-access-for-external-users": "Access to the serviceportal is restricted to SICK employees by default. If you want to grant access to external users, contact us via sickid-id-service@sick.com",
        "client-permissions-description": "Grant permissions to access this client's configuration. These can be used to enable different functionality for different users in the Service Portal.",
        "client-permissions-vs-roles": "Note: To differenciate users in your application, you should use the roles managed in the roles tab.",
        "client-role-mappers-description": "You can map specific roles of other clients if the other client has marked their role as publicly available or you have admin access to the other client.",
        "client-roles": "Client Roles",
        "client-roles-description": "These roles can be assigned to users of your application. If a user logs into your client, their roles for that client are automatically mapped into the user's token.",
        "client-roles-mapper-description": "Map all roles of another client into the user's token. This may be necessary if your application needs to check if the user has roles for another client. Another use case would be tokens that are used for multiple applications / audiences.",
        "client-templates": "Client Templates",
        "client-templates-explanation": "Select one of the predefined templates if they fit your use case.",
        "client-token-mappers-description": "Map some properties into the user's token. You can map user attributes, e.g. customer number, roles from different clients or audiences.",
        "clients": "Clients",
        "contact-us": "Contact Us",
        "create-client": "Create Client",
        "create-new-client": "Create a New Client",
        "create-new-customer-account": "Create a New Customer Account",
        "create-new-test-user": "Create New Test User",
        "creation-date": "Created At",
        "current-secret": "Current Secret",
        "custom-audience": "Custom Audience",
        "customer": "Customer",
        "customer-accounts": "Customer Accounts",
        "customer-name": "Customer Name",
        "customer-number": "Customer Number",
        "customer-search-explanation": "You can search for an email address, first or last name. Press Enter to start the search.",
        "dashboard": "Dashboard",
        "delete": "Delete",
        "delete-client": "Delete Client",
        "delete-client-confirmation": "Please enter the Client ID to confirm deletion.",
        "delete-client-warning": "Do you want to {$START_TAG_STRONG}permanently delete{$CLOSE_TAG_STRONG} the following client?",
        "delete-customer-account": "Delete Customer Account",
        "delete-customer-account-warning": "Do you want to {$START_TAG_STRONG}permanently delete{$CLOSE_TAG_STRONG} the following customer account?",
        "delete-member": "Delete Member",
        "delete-permission": "Delete Permission",
        "delete-permission-warning": "Do you want to {$START_TAG_STRONG}revoke{$CLOSE_TAG_STRONG} the permissions of {$INTERPOLATION}?",
        "delete-role": "Delete Role",
        "delete-role-confirmation": "Please enter the role name to confirm deletion.",
        "delete-role-warning": "Do you want to {$START_TAG_STRONG}permanently delete{$CLOSE_TAG_STRONG} the following client role?",
        "delete-role-warning-clientlist": "This role is mapped into the tokens of the following clients:",
        "delete-role-warning-clientlist-info": "These clients might rely on the role for their functionality.",
        "delete-test-user": "Delete Test User",
        "delete-test-user-warning": "Do you want to {$START_TAG_STRONG}permanently delete{$CLOSE_TAG_STRONG} the following test user?",
        "delete-token-mapper": "Delete Token Mapper",
        "delete-token-mapper-warning": "Do you want to {$START_TAG_STRONG}permanently delete{$CLOSE_TAG_STRONG} the following token mapper?",
        "demo-account": "Demo Account",
        "description": "Description",
        "disabled": "Disabled",
        "display-name": "Display Name",
        "download-as-csv": "Download as CSV",
        "edit-customer-account": "Edit Customer Account",
        "edit-role": "Edit Role",
        "edit-test-user": "Edit Test User",
        "edit-token-mapper": "Edit Token Mapper",
        "email": "Email",
        "email-verified": "Email Verified",
        "enabled": "Enabled",
        "enforce-mfa": "Enforce MFA",
        "enforce-mfa-help": "If this option is enabled, all users of your application need multi-factor authentication (MFA) for every login. Keep in mind that users without MFA are required to setup an authenticator during the login flow.",
        "enforce-pkce": "Enforce PKCE",
        "enforce-pkce-help": "This enforces PKCE during initial login, i.e. the request has to use the parameter 'code_challenge_method' with value 'S256'.",
        "error-bad-request": "Bad request.",
        "error-client-id-already-exists": "A client with the same client ID already exists.",
        "error-exporting-customers": "Exporting customers took too long. Try to narrow down your search criteria or try again later.",
        "error-no-customer-access": "You do not have access to the customer manager. You can request access via the following link:",
        "error-no-test-user-access": "You do not have access to the test user manager. You can request access via the following link:",
        "error-user-does-not-exist": "A user with the given username does not exist.",
        "error-user-has-permission": "The user already has a permission for this client.",
        "error-username-already-exists": "A user with this username already exists.",
        "export": "Export",
        "export-customer-accounts": "Export Customer Accounts",
        "feedback-description": "Get in touch with us when you need help or want additional features. We are happy to hear from you!",
        "first-name": "First Name",
        "first-name-help": "First name of the user.",
        "footer.imprint": "Imprint",
        "footer.privacyPolicy": "Privacy Policy",
        "footer.termsAndConditions": "Terms and Conditions",
        "footer.termsOfUse": "Terms of Use",
        "full-scope": "Full Scope",
        "full-scope-help": "Full scope maps all roles from all other tokens into the user's token. Try to avoid it by using explicit role mappers.",
        "get-tokens": "Get Tokens",
        "header.logout": "Logout",
        "header.myAccount": "My Account",
        "hello": "Hello",
        "home": "Home",
        "http-403-forbidden": "Access Denied, missing permissions.",
        "invalidate-rotated-secret": "Invalidate Rotated Secret",
        "issue": "Issue",
        "issues": "Issues",
        "last-email-verification-help": "Date on which the user was last asked to verify their email address. This does not indicate whether the user actually verified their email address.",
        "last-login": "Last Login",
        "last-name": "Last Name",
        "last-name-help": "Last name of the user.",
        "last-verification-email-sent": "Last Verification Email Sent",
        "level": "Level",
        "links-and-documentation": "Links and Documentation",
        "load-all-members": "Load All Members",
        "manage-customers": "Manage Customer Accounts",
        "mapper-type": "Mapper Type",
        "members": "Members",
        "missing-serviceportal-access": "User doesn't have access to the service portal.",
        "my-clients": "My OIDC Clients",
        "my-test-users": "My Test Users",
        "name": "Name",
        "next": "Next",
        "notes": "Notes",
        "notes-help": "Add free form notes to this account, e.g. why it was created.",
        "of": "of",
        "otp": "Time-based authenticators (6 digit codes)",
        "overview.client-list.description": "Get an overview of the different SICK ID clients.",
        "overview.client-list.open": "List Clients",
        "overview.client-list.title": "List SICK ID Clients",
        "overview.manage-clients.description": "Manage your SICK ID clients: {$START_UNORDERED_LIST}{$START_LIST_ITEM}Create or edit clients{$CLOSE_LIST_ITEM}{$START_LIST_ITEM}Create or assign roles{$CLOSE_LIST_ITEM}{$CLOSE_UNORDERED_LIST}",
        "overview.manage-clients.open": "Manage Clients",
        "overview.manage-clients.title": "Manage My SICK ID Clients",
        "overview.manage-customers.description": "Manage accounts for your customers: {$START_UNORDERED_LIST}{$START_LIST_ITEM}Create, edit or activate customer accounts{$CLOSE_LIST_ITEM}{$START_LIST_ITEM}Search and export customer accounts{$CLOSE_LIST_ITEM}{$CLOSE_UNORDERED_LIST}",
        "overview.manage-customers.open": "Manage Customers",
        "overview.manage-test-users.description": "Manage your SICK ID test users: {$START_UNORDERED_LIST}{$START_LIST_ITEM}Test common and edge cases in your application{$CLOSE_LIST_ITEM}{$START_LIST_ITEM}Create users and freely edit their attributes{$CLOSE_LIST_ITEM}{$CLOSE_UNORDERED_LIST}",
        "overview.manage-test-users.open": "Manage Test Users",
        "overview.manage-test-users.title": "Manage Test Users",
        "owners": "Owners",
        "owners-help": "Owners can edit and delete test users.",
        "password": "Password",
        "password-help": "Set a password for the user.",
        "password-requirements": "Password requirements:",
        "password-validators.has-lower-case": "At least one lower case letter (a-z)",
        "password-validators.has-min-length": "At least 8 characters",
        "password-validators.has-non-word-character": "At least one number (0-9) or a symbol",
        "password-validators.has-upper-case": "At least one upper case letter (A-Z)",
        "permission": "Permission",
        "permissions": "Permissions",
        "properties": "Properties",
        "public": "Public",
        "public-client": "Public Client",
        "public-client-help": "If this option is enabled, the client is public and doesn't need to have a secret. This client can be used in a standalone frontend application, which cannot store a client secret securely in a backend.",
        "public-client-warning": "Public clients do not have client secrets for client authentication. Disable \"Public Client\" in settings to start using client authenitcation or service accounts!",
        "questions-and-feedback": "Questions and Feedback",
        "reactivate-client": "Reactivate Client",
        "realm-roles": "Realm Roles",
        "remove": "Remove",
        "remove-attribute": "Remove Attribute",
        "remove-member": "Remove Member",
        "remove-mfa": "Remove MFA",
        "remove-owner": "Remove Owner",
        "remove-permission": "Remove Permission",
        "request-access": "Request Access",
        "reset-mfa": "Reset MFA",
        "reset-password": "Reset Password",
        "role-admin": "Role Admin",
        "role-admin-description": "Can create new roles and assign users to roles.",
        "role-clientlist": "Clients that use this role",
        "role-clientlist-info": "This role is mapped into the tokens of the following clients. {$LINE_BREAK}If you delete this role, these clients might not work as expected.",
        "role-description-help": "Document the purpose of this role.",
        "role-manager": "Role Manager",
        "role-manager-description": "Can only assign users to existing roles.",
        "role-mappers": "Role Mappers",
        "role-name-help": "The name of the role will be mapped into the token of the user's in that role.",
        "role-prefix": "Role Prefix",
        "role-public-help": "A public role can be mapped into tokens of other clients. If this role is only intended to be used by your client, leave this option disabled.",
        "roles": "Roles",
        "rotate-secret": "Rotate Secret",
        "rotated-secret": "Rotated Secret",
        "rotated-secret-valid-until": "Rotated secret is valid till:",
        "salutation": "Salutation",
        "salutation.mr": "Mr.",
        "salutation.ms": "Ms.",
        "save-changes": "Save Changes",
        "save-permission": "Save Permission",
        "search": "Search",
        "search-user-or-type-username": "Search for a user or type a username",
        "security-audit-intro": "Find security and maintenance issues in your client configuration.",
        "select-all": "(All)",
        "service-account": "Service Account",
        "service-account-help": "Enables a service account user that can authenticate via the the client credentials flow. You can use the service account for service-to-service communication.",
        "service-account-username": "Service Account Username",
        "service-to-service-communication": "Service-to-Service Communication",
        "service-url": "Service URL",
        "service-url-help": "The main entry point to your application. Users may be redirected to this URL after registration. Furthermore, this URL may be displayed to users viewing their active sessions.",
        "session": "Session",
        "session-note": "Session Note",
        "settings": "Settings",
        "sick-employee": "SICK Employee",
        "ssu-code": "SSU Code",
        "ssu-help": "Assign an SSU code to this account.",
        "start-editing": "Start Editing",
        "suffix": "Suffix",
        "template-custom-configuration": "Create a fully customizable OpenID client. This allows advanced users to configure their clients for specific use cases not covered by the other templates.",
        "template-service-to-service": "Create an OpenID client for authenticating backend services. A service account will be created that can authenticate via the client credentials flow.",
        "template-standalone-web-frontend": "Create an OpenID client for a web frontend, e.g. a Single-Page Application (SPA). Your users can directly authenticate with SICK ID via the browser authentication flow.",
        "templates": "Templates",
        "temporary": "Temporary",
        "temporary-password": "Temporary Password",
        "temporary-password-help": "Set an initial temporary password for the user.",
        "test-user-access-help": "You can see all test users that are associated with the client. If you cannot edit the test user, you can request access from the owners.",
        "test-user-associated-clients-help": "By associating clients with the test user, you can easily find all test users associated with a client.",
        "test-user-email-help": "The email address will be used to send verification and reset credentials emails. By default, the email address of the test user's creator is used.",
        "test-user-inactive-warning": "The test user has been inactive for a long time. Either log in with the test user or delete them.",
        "test-user-name-gen-help": "The username of the test user will be generated following this pattern. You can choose an existing client or a custom string as the application.",
        "test-user-sick-employee-help": "Determines whether the test user is considered to by a SICK employee.",
        "test-users": "Test Users",
        "text-search": "Text Search",
        "token-mapper-claim-name-help": "The claim name identifies the field name in the token into which the value will be mapped.",
        "token-mapper-client-audience-help": "Maps this client into the audience ('aud') field of the token.",
        "token-mapper-client-help": "ID of the client for which all roles should be mapped.",
        "token-mapper-custom-audience-help": "Maps this custom string into the audience ('aud') field of the token.",
        "token-mapper-display-name-help": "Human readable name for the token mapper. It has no influence on the token.",
        "token-mapper-role-prefix-help": "Appends a prefix to all mapped roles.",
        "token-mapper-session-note-help": "The part of the session information to map into the token.",
        "token-mapper-user-attribute-help": "Name of the user attribute that should be mapped into the token.",
        "token-mappers": "Token Mappers",
        "token-preview": "Token Preview",
        "token-preview-description": "Show example tokens for the selected client. This is useful for testing the client's scope evaluation.",
        "unexpected-error": "An unexpected error occured.",
        "unmet-requirements": "The following requirements are not met:",
        "url-prefix": "URL Prefix",
        "url-prefix-help": "This prefix allows you to avoid repetition when defining redirect and origin URLs. It is prepended to all relative URLs.",
        "user": "User",
        "user-attribute": "User Attribute",
        "user-attribute-mapper-description": "Map a specific user attribute into the token. For example, to map the customer number attribute, you can map the {$START_TAG_CODE}y_CustomerNumber{$CLOSE_TAG_CODE} attribute to the claim {$START_TAG_CODE}myCustomerNumber{$CLOSE_TAG_CODE} in the user's token.",
        "username": "Username",
        "username-help": "The username is part of the login credentials. It does not need to be a valid email address.",
        "uuid": "UUID",
        "valid-redirect-urls": "Valid Redirect URLs",
        "valid-redirect-urls-help": "Valid URI pattern a browser can redirect to after a successful login or logout. Simple wildcards are allowed i.e. 'https://cloud.sick.com/*' but no plain wildcards \"*\".",
        "warning-create-sick-employee": "It looks like you are trying to create a SICK employee via the customer manager. SICK employees are automatically created when they login for the first time. If you create a SICK employee via the customer manager, they will be missing important group and role associations.",
        "warning-issues-for-some-clients": "Some of your clients have security or maintenance issues. Inspect them via:",
        "web-origins": "Web Origins",
        "web-origins-help": "Define allowed access control origins. If you do not define your origins, you might encounter CORS errors. Do not enter relative paths, just enter the host itself, e.g. https://example.sick.com.",
        "welcome-to-the-portal": "Welcome to the SICK ID Self-Service Portal!"
    }
}
